import SalesOrdersByTimeList from './SalesOrdersByTimeList'

export default {
  list: SalesOrdersByTimeList,
}
